export const Footer = () => {
    return (
        <footer>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <a style={{opacity: 0.6, textDecoration: 'underline'}} href='/terms.html'>Terms and Conditions</a>
                <a style={{opacity: 0.6, textDecoration: 'underline'}} href='/privacy.html'>Privacy Policy</a>
            </div>
            <div className="footer__copyright">Fantik is official trademark belonging to <span>Asura Engineering Sp. z o.o.</span></div>
            <div className="footer__copyright">Fantik Android and iOS apps are developed by <span>Asura Engineering Sp. z o.o.</span></div>
        </footer>
    )
}